export type UserType = 'MANAGER' | 'ENDUSER' | 'ADMIN';

export type SingleUser = {
	userId: string;
	userName: string;
	userType?: UserType;
	accountId?: string;
	accountName?: string;
	departmentId: string;
	departmentName?: string;
	corpDepartmentId?: string;
	departmentUiColor?: string;
	permissionExpiration: string;
	permissionDepartmentIds: string[];
};

const model: types.models.InputModel = {
	userId: 'userId',
	userName: 'userName',
	userType: 'userType',
	accountId: 'accountId',
	accountName: 'accountName',
	departmentId: 'departmentId',
	departmentName: 'departmentName',
	corpDepartmentId: 'corpDepartmentId',
	departmentUiColor: 'departmentUiColor',
	permissionExpiration: 'permissionExpiration',
	permissionDepartmentIds: ['permissionDepartmentIds', []],
};

export default model;
